import React from 'react';
import type { OrderStepContext } from '../orderStepContext';
import { OrderGuideBelow } from './OrderGuidePanel';
import OrderMarginCard from './OrderMarginCard';

/**
 * „Marża zamówienia” across the whole width under the step content on steps
 * 1–3. The first mockup's „Po stronie Valentyny” lane was dropped (owner
 * decision 2026-10-05): what Logistyk does is shown by the confirmation
 * window and the draft ZD, not by a second tile.
 */
export default function OrderGuideBelowRow({ ctx, marginStale = false }: { ctx: OrderStepContext; marginStale?: boolean }) {
  return (
    <OrderGuideBelow>
      <OrderMarginCard ctx={ctx} stale={marginStale} />
    </OrderGuideBelow>
  );
}
